<div
  class="det-default-available-offers-container"
  *ngIf="availableOffers?.length"
>
  <div class="det-text-available-offers-title">Available Offers</div>

  <ul class="det-default-available-offers-list-wrapper">
    <li
      class="det-default-available-offers-list"
      *ngFor="let offer of availableOffers; let i = index"
    >
      <div class="accordion-header">
        <div
          class="det-text-offer-name"
          data-bs-toggle="collapse"
          [attr.data-bs-target]="'#collapse' + i"
          role="button"
        >
          <svg
            class="det-image-available-offers-icon"
            [ngStyle]="{ width: '15px', height: '15px' }"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
          >
            <path [attr.d]="DRAWING_INSTRUCTION.OFFER_TAG" />
          </svg>
          {{ offer.offer_name }}
          <p class="caption" *ngIf="offer.offer_type === 'discount'">
            Get {{ offer.discount_rate }}% Off
            {{
              offer.minimum_quantity > 1
                ? 'on purchase of ' + offer.minimum_quantity + ' or more items'
                : ''
            }}
            – Save up to ₹{{ offer.savings }}
          </p>
          <p class="caption" *ngIf="offer.offer_type === 'bundle_items'">
            Buy {{ offer.minimum_quantity }}, get
            {{ offer.bundle_item_quantity }} free -
            <span [title]="offer.bundle_item.name">
              {{ offer.bundle_item.name }}</span
            >!
          </p>
          <p class="caption" *ngIf="offer.offer_type === 'cash_points'">
            Earn
            <cash-point-svg
              class="selector-cashpoint"
              width="12"
              height="12"
            ></cash-point-svg>
            {{ offer.cash_points | mathFloor }} Cash Points
          </p>

          <p class="caption" *ngIf="offer.offer_type === 'flat_amount'">
            Get ₹{{ offer.discount_rate }} Flat Discount
            {{
              offer.minimum_quantity > 1
                ? 'on purchase of ' + offer.minimum_quantity + ' or more items'
                : ''
            }}
          </p>
        </div>

        <div
          class="det-default-accordion-actions"
          *ngIf="offer.terms || offer.description"
        >
          <div class="det-default-available-offers-tc" *ngIf="offer.terms">
            <span
              class="det-text-available-offers-tc"
              (click)="openTermsCondition(i, true)"
            >
              T&C
            </span>
            <div
              #termsContainer
              *ngIf="isOpenTermsCondition && activeOfferIndex === i"
              class="terms-container"
            >
              <div class="terms" [innerHTML]="offer.terms | safeHtml"></div>
            </div>
          </div>

          <img
            *ngIf="offer.description"
            class="accordion-icon collapsed"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse' + i"
            role="button"
            src="/assets/images/down-arrow.svg"
          />
        </div>
      </div>

      <div [id]="'collapse' + i" class="accordion-collapse collapse">
        <div
          *ngIf="offer.description"
          class="det-text-offer-description"
          [innerHTML]="offer.description | safeHtml"
        ></div>
      </div>
    </li>
  </ul>

  <button
    *ngIf="viewMore"
    class="det-view-less-more-btn view-more-content"
    (click)="toggleViewMoreOffers($event)"
  >
    {{ isExpanded ? 'View Less' : 'View More' }}
  </button>
</div>
